import config from "../config.json";
import { useMap } from "react-leaflet";
import L from "leaflet";
import React, { useEffect, useRef, useState } from "react";
import "./AddTileLayer.css";

export default function AddTileLayer() {

  const map = useMap();
  const controlRef = useRef(null);
  const defaultLayerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {

    if (!map || controlRef.current) return;

    /* ---------- Remote Layers ---------- */

    const osm = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      {
        maxZoom: 19,
        attribution: "© noron",
        subdomains: ["a","b","c"],
        crossOrigin: true,
        keepBuffer: 6
      }
    );

    const mapboxSat = L.tileLayer(
      `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${config.mapBoxKey}`,
      {
        maxZoom: 19,
        tileSize: 256,
        zoomOffset: 0,
        crossOrigin: true,
        keepBuffer: 6
      }
    );

    const googleRoad = L.tileLayer(
      "https://mt{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      {
        maxZoom: 19,
        subdomains: ["0","1","2","3"],
        crossOrigin: true,
        keepBuffer: 6
      }
    );

    const googleSat = L.tileLayer(
      "https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      {
        maxZoom: 19,
        subdomains: ["0","1","2","3"],
        crossOrigin: true,
        keepBuffer: 6
      }
    );

    const googleHybrid = L.tileLayer(
      "https://mt{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
      {
        maxZoom: 19,
        subdomains: ["0","1","2","3"],
        crossOrigin: true,
        keepBuffer: 6
      }
    );

    /* ---------- Local Layers ---------- */

    const localOsm = L.tileLayer(
      `${config.mapUrl}/api/tiles/cache/osm/{z}/{x}/{y}.png`,
      { maxZoom: 19, keepBuffer: 6 }
    );

    const localMapir = L.tileLayer(
      `${config.mapUrl}/api/tiles/cache/mapir1/{z}/{x}/{y}.png`,
      { maxZoom: 19, keepBuffer: 6 }
    );

    const localSat = L.tileLayer(
      `${config.mapUrl}/api/tiles/cache/mapbox/{z}/{x}/{y}.png`,
      { maxZoom: 19, keepBuffer: 6 }
    );

    /* ---------- Layers List ---------- */

    const baseLayers = {
      "سرویس محلی 1": localOsm,
      "سرویس محلی 2": localMapir,
      "ماهواره محلی": localSat,
      "OSM جهانی": osm,
      "MapBox ماهواره": mapboxSat,
      "Google Road": googleRoad,
      "Google Satellite": googleSat,
      "Google Hybrid": googleHybrid
    };

    /* ---------- Default Layer ---------- */

    defaultLayerRef.current = localOsm;
    localOsm.addTo(map);

    /* ---------- Control ---------- */

    const control = L.control.layers(baseLayers, null, {
      position: "topleft",
      collapsed: false
    });

    controlRef.current = control;

    /* ---------- Remove previous layer ---------- */

    map.on("baselayerchange", (e) => {
      if (defaultLayerRef.current && map.hasLayer(defaultLayerRef.current)) {
        map.removeLayer(defaultLayerRef.current);
      }

      defaultLayerRef.current = e.layer;
    });

    return () => {

      map.off("baselayerchange");

      if (defaultLayerRef.current) {
        map.removeLayer(defaultLayerRef.current);
      }

      if (controlRef.current) {
        controlRef.current.remove();
        controlRef.current = null;
      }
    };

  }, [map]);

  /* ---------- Toggle Control ---------- */

  useEffect(() => {

    if (!controlRef.current) return;

    if (visible)
      controlRef.current.addTo(map);
    else
      controlRef.current.remove();

  }, [visible, map]);

  return (
    <div
      className="custom-layer-toggle"
      onClick={() => setVisible(!visible)}
    >
      🗺️
    </div>
  );
}
